export default {"src":"/_next/static/media/sqaure-pattern-dark.4b60f62a.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};